{
  "lastUpdatedAt": "2026-05-05T12:19:06.487Z",
  "lastFetchAttemptAt": "2026-05-05T12:19:06.487Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}